import apiClient, { extractData } from "./client";

export async function getAppeals(params = {}) {
  const response = await apiClient.get("/appeals", { params });
  return extractData(response);
}

export async function createAppeal(data) {
  const response = await apiClient.post("/appeals", data);
  return extractData(response);
}

export async function respondToAppeal(id, data) {
  const response = await apiClient.post(`/appeals/${id}/respond`, data);
  return extractData(response);
}

export async function getAppealTransferTargets(id) {
  const response = await apiClient.get(`/appeals/${id}/transfer-targets`);
  return extractData(response);
}

export async function transferAppeal(id, data) {
  const response = await apiClient.post(`/appeals/${id}/transfer`, data);
  return extractData(response);
}
